import {
	createTheme,
} from '@mui/material'

export const materialUIPaletteTheme = createTheme({
	palette: {

		/* common */
		hint: '--on-surface-color-hint',

		/* gray */
		'gray-100': 'var(--gray-color-100)',
		'gray-200': 'var(--gray-color-200)',
		'gray-300': 'var(--gray-color-300)',
		'gray-400': 'var(--gray-color-400)',
		'gray-500': 'var(--gray-color-500)',
		'gray-600': 'var(--gray-color-600)',
		'gray-700': 'var(--gray-color-700)',
		'gray-800': 'var(--gray-color-800)',
		'gray-900': 'var(--gray-color-900)',
	},
})
